module.exports = {"object":"value","document":{"object":"document","nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"Slate editors save all changes to an internal \"history\" automatically, so you don't need to implement undo/redo yourself. And the editor automatically binds to the browser's default undo/redo keyboard shortcuts."}]},{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"Try it out for yourself! Make any changes you'd like then press \"cmd+z\"."}]}]}}


//////////////////
// WEBPACK FOOTER
// ./examples/history/value.json
// module id = 766
// module chunks = 0